export const className = {
  image: `articlePreview_image_area`,
  titleArea: `articlePreview_title_area`,
  contextArea: `articlePreview_context_area`,
  context: `articlePreview_context`,
}
